import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { notifyError } from "../../../components/ui";
import { getSpacesSettings, setPublicPage } from "../services/amenitiesApi";
import { apiErrorMessage } from "../services/basesApi";
import { useUserStore } from "../../../store/userStore";

// Interruptor de la página pública de espacios (/espacios/:companyId). Nace
// apagada: hasta que la compañía la prende, el API público responde 404.
export default function PublicPageToggle() {
  const { t } = useTranslation("bases");
  const user = useUserStore((s) => s.user) as { company_id?: string } | null;
  const [on, setOn] = useState<boolean | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getSpacesSettings()
      .then((s) => setOn(s.publicPage))
      .catch(() => setOn(null));
  }, []);

  const toggle = async () => {
    if (on === null) return;
    setBusy(true);
    try {
      setOn((await setPublicPage(!on)).publicPage);
    } catch (err) {
      notifyError(apiErrorMessage(err, t("common.saveError")));
    } finally {
      setBusy(false);
    }
  };

  const companyId = user?.company_id || localStorage.getItem("companyId") || "";
  return (
    <div className="flex items-center gap-2 rounded-lg border border-line bg-card px-3 py-1.5 text-sm" title={t("publicPage.help")}>
      <button
        type="button"
        role="switch"
        aria-checked={on === true}
        disabled={busy || on === null}
        onClick={() => void toggle()}
        className={`relative h-5 w-9 rounded-full transition-colors disabled:opacity-50 ${on ? "bg-success" : "bg-subtle"}`}
      >
        <span className={`absolute top-0.5 h-4 w-4 rounded-full bg-white shadow transition-all ${on ? "left-[18px]" : "left-0.5"}`} />
      </button>
      <span className="whitespace-nowrap text-content">{t("publicPage.label")}</span>
      {on && companyId ? (
        <a href={`/espacios/${encodeURIComponent(companyId)}`} target="_blank" rel="noreferrer" className="text-primary-500 hover:underline" aria-label={t("publicPage.open")}>
          <i className="ri-external-link-line" />
        </a>
      ) : null}
    </div>
  );
}
